const profileAttachments = {
    "data": {
        "attachments": [
            {
                "creationDate": 1593553403439,
                "fileName": "202006251649_MASTER_16.7.30218.14_11212_103bfcd1-ed5c-46b7-890f-d4dda8da23cc.tcdb",
                "problemLink": "https://developercommunity.visualstudio.com/content/problem/1097036/vsftest-making-this-longer.html",
                "problemTitle": "vsftest making this longer",
                "url": "/api/fileBlobMetrics/getAzureBlobFromTransferId?transferId=a1e94427010d427d8e591a5f3b7e0844637291502036184414"
            },
            {
                "creationDate": 1593553401658,
                "fileName": "Scr_gfbjwgfj.r3h.jpg",
                "problemLink": "https://developercommunity.visualstudio.com/content/problem/1097036/vsftest-making-this-longer.html",
                "problemTitle": "vsftest making this longer",
                "url": "/api/fileBlobMetrics/getAzureBlobFromTransferId?transferId=4c9568e715e64387959f6a03f35ae0c6637291502018819632"
            },
            {
                "creationDate": 1593553400506,
                "fileName": "VSInMemoryActivityLog_2020-06-30_21-41-06.xml",
                "problemLink": "https://developercommunity.visualstudio.com/content/problem/1097036/vsftest-making-this-longer.html",
                "problemTitle": "vsftest making this longer",
                "url": "/api/fileBlobMetrics/getAzureBlobFromTransferId?transferId=762f4a85f08f4718864def4a33d89841637291502006940115"
            },
            {
                "creationDate": 1593553399656,
                "fileName": "LocalInfo_2020-06-30_21-41-06.json",
                "problemLink": "https://developercommunity.visualstudio.com/content/problem/1097036/vsftest-making-this-longer.html",
                "problemTitle": "vsftest making this longer",
                "url": "/api/fileBlobMetrics/getAzureBlobFromTransferId?transferId=37dd2069320542d7850daf19f9927bea637291501998591907"
            },
            {
                "creationDate": 1593553398448,
                "fileName": "Microsoft.VisualStudio.Default.err",
                "problemLink": "https://developercommunity.visualstudio.com/content/problem/1097036/vsftest-making-this-longer.html",
                "problemTitle": "vsftest making this longer",
                "url": "/api/fileBlobMetrics/getAzureBlobFromTransferId?transferId=a14b5d7dae0d496db58da1ae9d8e8788637291501986377024"
            },
            {
                "creationDate": 1593553397380,
                "fileName": "ServiceHubLogs_2020-06-30-14-41-06.zip",
                "problemLink": "https://developercommunity.visualstudio.com/content/problem/1097036/vsftest-making-this-longer.html",
                "problemTitle": "vsftest making this longer",
                "url": "/api/fileBlobMetrics/getAzureBlobFromTransferId?transferId=3e789ee9bbb847f78cef6681246350ca637291501976918161"
            },
            {
                "creationDate": 1593553396571,
                "fileName": "devenv.isolation.ini",
                "problemLink": "https://developercommunity.visualstudio.com/content/problem/1097036/vsftest-making-this-longer.html",
                "problemTitle": "vsftest making this longer",
                "url": "/api/fileBlobMetrics/getAzureBlobFromTransferId?transferId=9acee1192f5e4aefb9c326e45ec47a6b637291501967448834"
            },
            {
                "creationDate": 1593553395565,
                "fileName": "Microsoft.VisualStudio.Default.scan",
                "problemLink": "https://developercommunity.visualstudio.com/content/problem/1097036/vsftest-making-this-longer.html",
                "problemTitle": "vsftest making this longer",
                "url": "/api/fileBlobMetrics/getAzureBlobFromTransferId?transferId=2b57fe3cac964344a289bc12e89dee6d637291501959424491"
            },
            {
                "creationDate": 1593553394706,
                "fileName": "WatsonEventLog_2020-06-30_21-41-06.txt",
                "problemLink": "https://developercommunity.visualstudio.com/content/problem/1097036/vsftest-making-this-longer.html",
                "problemTitle": "vsftest making this longer",
                "url": "/api/fileBlobMetrics/getAzureBlobFromTransferId?transferId=d2b162b70b974e9aad47eb9fc423d7c0637291501949034806"
            },
            {
                "creationDate": 1593553393256,
                "fileName": "DotNetEventLog_2020-06-30_21-41-06.txt",
                "problemLink": "https://developercommunity.visualstudio.com/content/problem/1097036/vsftest-making-this-longer.html",
                "problemTitle": "vsftest making this longer",
                "url": "/api/fileBlobMetrics/getAzureBlobFromTransferId?transferId=b0a364a5ac0549ae936e966a78217162637291501936527844"
            }
        ]
    }
}
export default profileAttachments; 